// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueTimeago from 'vue-timeago'
import Nl2br from 'vue-nl2br'
import Axios from 'axios'
import BootstrapVue from 'bootstrap-vue'
import VueCookies from 'vue-cookies'
import './assets/custom.scss'

// From https://scotch.io/tutorials/handling-authentication-in-vue-using-vuex
Vue.prototype.$http = Axios
const token = localStorage.getItem('token')
if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = token
}

Vue.component('nl2br', Nl2br)
// Vue.forceUpdate();

Vue.config.productionTip = false

Vue.use(BootstrapVue)

Vue.use(VueCookies)
VueCookies.config('365d')
Vue.use(VueTimeago, {
  name: 'Timeago', // Component name, `Timeago` by default
  locale: 'en', // Default locale
  // We use `date-fns` under the hood
  // So you can use all locales from it
  locales: {
    'zh-CN': require('date-fns/locale/zh_cn'),
    ja: require('date-fns/locale/ja')
  }
})/* eslint-disable no-new */

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})
